import React, { Component } from 'react'
import { Form, Modal, AutoComplete, Input, Icon, message } from 'antd'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import Loader from '../../common/Loader'
import { actions as vendorActions } from '../../../redux/modules/jobFunctions/jobVendorActions'
import { actions as itemActions } from '../../../redux/modules/jobFunctions/itemActions'
import { actions as purchaseOrderActions } from '../../../redux/modules/jobFunctions/purchaseOrderActions'
import { convertToOption, getModalId } from '../../../util'
import _ from 'lodash'
import OrganizationQuickAdd from '../../../components/organization//OrganizationQuickAdd'
import { actions as organizationsActions } from '../../../redux/modules/organizationsActions'
import history from '../../../history'

import VendorView from '../../../components/VendorView'

const FormItem = Form.Item
const propTypes = {}

class JobVendors extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsShowing: false,
      currentId: 0,
      contentData: null,
      purchaseOrderCurrentId: null,
      modalEditPurchaseOrderIsShowing: false,
      currentVendorId: 0
    }
  }

  componentDidMount() {
    const showModal = /modal\/\d+$/.test(window.location.href)

    if (showModal) {
      // open related vendor
      this.props.getVendorPurchaseOrder({
        jobId: this.props.jobId,
        next: (err, payload) => {
          const purchaseOrderId = getModalId(this.props.location.pathname)
          if (purchaseOrderId) {
            if (!err) {
              const results = _.get(payload, 'data')
              const current = _.find(results, { id: parseInt(purchaseOrderId, 10) })
              if (current) {
                this.setState({
                  currentVendorId: current.organization_id
                })
              } else {
                message.warning('This Purchase Order was deleted or does not exist.')
              }
            }
          }
        }
      })
    }

    this.props.jobVendorsRefresh({
      jobId: this.props.jobId
    })
  }

  showModal = () => {
    this.setState({
      modalVisible: true
    })
  }

  handleRowClick = row => {
    this.setState({
      modalVisible: true,
      currentId: row.id,
      contentData: row
    })
  }

  handleAddButton = () => {
    this.props.getAllVendors()
    this.setState({
      modalVisible: true,
      currentId: 0,
      contentData: null
    })
  }

  handleCancel = () => {
    this.props.form.resetFields()
    this.setState({ data: [], currentId: 0, modalVisible: false })
  }

  getSelectedCompany = value => {
    const companies =
      this.props.jobVendorActions &&
      this.props.jobVendorActions.allVendors &&
      this.props.jobVendorActions.allVendors.data
    const selectedCompany = companies.find(job => job.name === value)
    return selectedCompany ? +selectedCompany.id : +value
  }

  handleCreate = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }

      values.vendor = this.getSelectedCompany(values.vendor)

      this.props.addJobVendor({
        jobId: this.props.jobId,
        vendorId: values.vendor,
        userId: this.props.user.userId
      })

      form.resetFields()
      message.success('Changes saved.')
      this.setState({ contentData: null, currentId: 0, modalVisible: false })
    })
  }

  confirmDelete = () => {
    const form = this.props.form

    this.props.deleteJobVendor({
      jobId: this.props.jobId,
      attachmentId: this.state.currentId
    })

    form.resetFields()
    message.success('Record deleted.')
    this.setState({
      contentData: null,
      currentId: 0,
      modalVisible: false
    })
  }

  handleSearch = value => {
    this.setState({
      dataSource: !value ? [] : [value, value + value, value + value + value]
    })
  }

  uploadVendorAttachment = uploadParam => {
    const formData = new FormData()

    formData.append('file', uploadParam.file)
    formData.append('type', 'job_vendor')
    formData.append('created_by_id', this.props.user.userId)
    formData.append('updated_by_id', this.props.user.userId)
    formData.append('filename', uploadParam.file.name)
    formData.append('description', uploadParam.file.name)
    formData.append('organizationId', uploadParam.data.organizationId)

    this.props.uploadAttachment({
      formData: formData,
      jobId: this.props.jobId,
      organizationId: uploadParam.data.organizationId
    })
  }

  handleAttachmentRowClick = row => {
    this.setState({
      attachmentDetailsVisible: true,
      attachmentId: row.id,
      attachmentName: row.filename,
      attachmentDescription: row.description
    })
  }

  onDescriptionChange = e => {
    this.setState({
      attachmentDescription: e.target.value
    })
  }

  handleUpdateAttachmentDescription = () => {
    this.props.updateAttachmentDescription({
      description: this.state.attachmentDescription,
      attachmentId: this.state.attachmentId,
      jobId: this.props.jobId,
      organizationId: this.state.organizationId,
      userId: this.props.user.userId
    })
    this.setState({
      attachmentDetailsVisible: false
    })
  }

  confirmAttachmentDelete = event => {
    this.props.deleteAttachment({
      attachmentId: this.state.attachmentId,
      jobId: this.props.jobId,
      organizationId: this.state.organizationId
    })
    this.setState({
      attachmentDetailsVisible: false
    })
  }

  vendorPanelChange = panelKey => {
    if (panelKey) {
      this.setState({
        organizationId: panelKey
      })

      this.props.getAttachments({
        organizationId: panelKey,
        jobId: this.props.jobId
      })
    }
  }

  deleteVendor = () => {
    this.props.deleteJobVendor({
      jobId: this.props.jobId,
      organizationId: this.state.organizationId
    })
  }

  handlePurchaseOrderOpenModal = purchaseOrderCurrentId => {
    this.setState({
      purchaseOrderCurrentId: purchaseOrderCurrentId,
      modalEditPurchaseOrderIsShowing: true
    })
  }

  handlePurchaseOrderCloseModal = () => {
    const { jobType, jobId } = this.props.match.params
    this.props.getVendorPurchaseOrder({ jobId: this.props.jobId })
    this.setState({
      purchaseOrderCurrentId: 0,
      modalEditPurchaseOrderIsShowing: false
    })
    history.push(`/jobView/${jobId}/${jobType}/vendors`)
  }

  handleDeletePurchaseOrder = () => {
    this.props.deletePurchaseOrder({
      purchaseOrderId: this.state.purchaseOrderCurrentId,
      jobId: this.props.jobId
    })

    this.handlePurchaseOrderCloseModal()
  }

  /* Organization Quick Add */
  handleQuickAddOrganization = organization => {
    this.props.createNewOrganization({
      organization: organization,
      userId: this.props.user.userId
    })
    setTimeout(() => {
      this.props.getAllVendors()
    }, 1000)
  }

  handleBlurOrganization = organization => {
    if (organization !== '')
      this.setState({
        quickAddModalVisibility:
          _.findIndex(this.props.jobVendorActions.allVendors.data, { id: +organization }) < 0 &&
          _.findIndex(this.props.jobVendorActions.allVendors.data, { name: organization }) < 0
            ? true
            : false
      })
  }

  handleCancelQuickAdd = () => {
    this.setState({
      quickAddModalVisibility: !this.state.quickAddModalVisibility
    })
  }
  /* End Organization Quick Add */

  /* Begin Item Quick Add Actions */
  createNewItem = params => {
    this.props.createNewItem({
      item: params.values,
      userId: this.props.user.userId
    })

    this.props.getAllItems()
  }
  /* End Item Quick Add Actions */

  shouldRenderModal = organizationId => {
    const { clickedOrganizationId } = this.state
    if (clickedOrganizationId !== organizationId && clickedOrganizationId) {
      return false
    } else {
      return /modal\/\d+$/.test(window.location.href)
    }
  }

  setVendorClicked = organizationId => {
    this.setState({
      clickedOrganizationId: organizationId
    })
  }

  render() {
    if (!this.props.jobVendorActions.jobVendors) {
      return <Loader />
    }
    const { getFieldDecorator } = this.props.form

    const allItems = _.get(this.props, 'itemActions.allItems.data')

    return (
      <div>
        <OrganizationQuickAdd
          modalVisible={this.state.quickAddModalVisibility}
          handleCancel={this.handleCancelQuickAdd}
          handleQuickAddOrganization={this.handleQuickAddOrganization}
          organizartionType={'Vendor'}
        />
        <Modal
          visible={this.state.modalVisible}
          title="Add a vendor"
          okText={'Add'}
          onCancel={this.handleCancel}
          onOk={this.handleCreate}
          maskClosable={false}
        >
          <Form layout="vertical">
            <FormItem>
              {getFieldDecorator('vendor', {})(
                <AutoComplete
                  dataSource={
                    this.props.jobVendorActions.allVendors
                      ? convertToOption(this.props.jobVendorActions.allVendors.data)
                      : []
                  }
                  style={{ width: 320 }}
                  filterOption={(inputValue, option) =>
                    option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                  }
                  placeholder="Search for a vendor"
                  onBlur={this.handleBlurOrganization}
                >
                  <Input suffix={<Icon type="search" className="certain-category-icon" />} />
                </AutoComplete>
              )}
            </FormItem>
          </Form>
        </Modal>
        <div className="jobsBar">
          Job Vendors
          <div className="jobsBarAdd">
            <i className="fa fa-plus-square" aria-hidden="true" />
            &nbsp;
            <div onClick={() => this.handleAddButton()} className="addJobLabel">
              ADD Vendor
            </div>
          </div>
        </div>
        <VendorView
          data={this.props.jobVendorActions.jobVendors.data}
          allVendors={
            this.props.jobVendorActions &&
            this.props.jobVendorActions.allVendors &&
            this.props.jobVendorActions.allVendors.data
          }
          userId={this.props.user.userId}
          getAllVendors={this.props.getAllVendors}
          getAllItems={this.props.getAllItems}
          vendorPurchaseOrders={this.props.jobVendorActions.vendorPurchaseOrders}
          createVendorPurchaseOrder={this.props.createVendorPurchaseOrder}
          updateVendorPurchaseOrder={this.props.updateVendorPurchaseOrder}
          getVendorPurchaseOrder={this.props.getVendorPurchaseOrder}
          jobId={this.props.jobId}
          allItems={allItems}
          getPurchaseOrder={this.props.getPurchaseOrder}
          purchaseOrder={
            this.props.purchaseOrder &&
            this.props.purchaseOrder.purchaseOrder &&
            this.props.purchaseOrder.purchaseOrder.data
          }
          uploadingAttachments={this.props.jobVendorActions.uploadingAttachment}
          deletingAttachment={this.props.jobVendorActions.deletingAttachment}
          loadingAttachments={this.props.jobVendorActions.loadingAttachments}
          jobVendorAttachments={
            this.props.jobVendorActions.jobAttachments &&
            this.props.jobVendorActions.jobAttachments.data
          }
          attachmentDetailsVisible={this.state.attachmentDetailsVisible}
          confirmAttachmentDelete={this.confirmAttachmentDelete}
          handleUpdateAttachmentDescription={this.handleUpdateAttachmentDescription}
          onDescriptionChange={this.onDescriptionChange}
          handleAttachmentRowClick={this.handleAttachmentRowClick}
          uploadVendorAttachment={this.uploadVendorAttachment}
          attachmentDescription={this.state.attachmentDescription}
          attachmentName={this.state.attachmentName}
          confirmDelete={this.confirmDelete}
          vendorPanelChange={this.vendorPanelChange}
          deleteVendor={this.deleteVendor}
          handleDeletePurchaseOrder={this.handleDeletePurchaseOrder}
          handlePurchaseOrderOpenModal={this.handlePurchaseOrderOpenModal}
          handlePurchaseOrderCloseModal={this.handlePurchaseOrderCloseModal}
          handlePurchaseOrderCurrentId={this.handlePurchaseOrderCurrentId}
          modalEditPurchaseOrderIsShowing={this.state.modalEditPurchaseOrderIsShowing}
          createNewItem={this.createNewItem}
          shouldRenderModal={this.shouldRenderModal}
          currentVendorId={this.state.currentVendorId}
          setVendorClicked={this.setVendorClicked}
        />
      </div>
    )
  }
}

const mapStateToProps = (
  { jobVendorActions, itemActions, purchaseOrder, organizationsActions },
  ownProps
) => ({
  jobVendorActions,
  itemActions,
  purchaseOrder,
  organizationsActions
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(
    Object.assign({}, itemActions, vendorActions, purchaseOrderActions, organizationsActions),
    dispatch
  )
})

JobVendors.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form.create()(JobVendors)))



// WEBPACK FOOTER //
// ./src/containers/job/tasks/JobVendors.js